"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureCanvas = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const SignatureCanvas = ({ className, canvasRef, readOnly, focussed }) => ((0, jsx_runtime_1.jsx)("canvas", { className: (0, lib_1.classnames)(className, (0, lib_1.bem)('signature-pad', (0, lib_1.use)(focussed, '--focussed'), (0, lib_1.use)(readOnly, '--read-only'))), ref: canvasRef }, void 0));
exports.SignatureCanvas = SignatureCanvas;
//# sourceMappingURL=SignatureCanvas.js.map